module.exports = __webpack_public_path__ + "asset/image-Property-1-Receipt-2d9347944dbf0d3e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Property-1-Receipt.svg
// module id = uJqd
// module chunks = 0